import withCSSVariables from "./withCSSVariables";

function withTheme(themeFunc) {
    return withCSSVariables([
        {
            cssName: "--theme-primary",
            value: themeFunc,
        },
    ]);
}

export function withConstantTheme(themeValue) {
    return withTheme(() => themeValue);
}
